// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern App Container */
.App {
  text-align: left;
  background-color: #F8FAFC;
  color: #0F172A;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.dark .App {
  background-color: #0B1120;
  color: #E2E8F0;
}

/* App Header - Modern Hero Section */
.App-header {
  background: linear-gradient(135deg, #F8FAFC 0%, #E0F2FE 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: #0F172A;
  position: relative;
  overflow: hidden;
}

.dark .App-header {
  background: linear-gradient(135deg, #0B1120 0%, #0C4A6E 100%);
  color: #E2E8F0;
}

/* Animated Background Gradient */
.App-header::before {
  content: '';
  position: absolute;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(2, 132, 199, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  top: -100px;
  right: -100px;
  animation: float 6s ease-in-out infinite;
}

.App-header::after {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  bottom: -50px;
  left: -50px;
  animation: float-reverse 8s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(30px, -30px); }
}

@keyframes float-reverse {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-30px, 30px); }
}

/* Logo Animation */
.App-logo {
  height: 40vmin;
  pointer-events: none;
  animation: App-logo-pulse 2s ease-in-out infinite;
}

@keyframes App-logo-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Link Styling */
.App-link {
  color: #2563EB;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
  border-bottom: 2px solid transparent;
}

.App-link:hover {
  color: #1D4ED8;
  border-bottom-color: #2563EB;
}

.dark .App-link {
  color: #38BDF8;
}

.dark .App-link:hover {
  color: #7DD3FC;
}

/* Main Content Container */
.App > main {
  flex: 1 1;
  width: 100%;
}

/* Root Container */
#root {
  width: 100%;
  min-height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,6DAA6D;EAC7D,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,iCAAiC,EAAE;AAC3C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,iCAAiC,EAAE;AAC3C;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["/* Modern App Container */\n.App {\n  text-align: left;\n  background-color: #F8FAFC;\n  color: #0F172A;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.dark .App {\n  background-color: #0B1120;\n  color: #E2E8F0;\n}\n\n/* App Header - Modern Hero Section */\n.App-header {\n  background: linear-gradient(135deg, #F8FAFC 0%, #E0F2FE 100%);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: #0F172A;\n  position: relative;\n  overflow: hidden;\n}\n\n.dark .App-header {\n  background: linear-gradient(135deg, #0B1120 0%, #0C4A6E 100%);\n  color: #E2E8F0;\n}\n\n/* Animated Background Gradient */\n.App-header::before {\n  content: '';\n  position: absolute;\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(2, 132, 199, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n  top: -100px;\n  right: -100px;\n  animation: float 6s ease-in-out infinite;\n}\n\n.App-header::after {\n  content: '';\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, rgba(37, 99, 235, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n  bottom: -50px;\n  left: -50px;\n  animation: float-reverse 8s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translate(0, 0); }\n  50% { transform: translate(30px, -30px); }\n}\n\n@keyframes float-reverse {\n  0%, 100% { transform: translate(0, 0); }\n  50% { transform: translate(-30px, 30px); }\n}\n\n/* Logo Animation */\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n  animation: App-logo-pulse 2s ease-in-out infinite;\n}\n\n@keyframes App-logo-pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n/* Link Styling */\n.App-link {\n  color: #2563EB;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s ease;\n  border-bottom: 2px solid transparent;\n}\n\n.App-link:hover {\n  color: #1D4ED8;\n  border-bottom-color: #2563EB;\n}\n\n.dark .App-link {\n  color: #38BDF8;\n}\n\n.dark .App-link:hover {\n  color: #7DD3FC;\n}\n\n/* Main Content Container */\n.App > main {\n  flex: 1;\n  width: 100%;\n}\n\n/* Root Container */\n#root {\n  width: 100%;\n  min-height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
